interface PixelCoffeeProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const PixelCoffee = ({ size = 'md', className = '' }: PixelCoffeeProps) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-12 h-12',
    lg: 'w-24 h-24',
  };

  return (
    <div className={`${sizeClasses[size]} ${className} relative`}>
      <svg
        viewBox="0 0 16 16"
        className="w-full h-full"
        style={{ imageRendering: 'pixelated' }}
      >
        {/* Steam particles - animated */}
        <g className="animate-steam">
          <rect x="5" y="1" width="1" height="1" fill="#9ca3af" opacity="0.8" />
          <rect x="7" y="0" width="1" height="1" fill="#9ca3af" opacity="0.6" />
          <rect x="9" y="1" width="1" height="1" fill="#9ca3af" opacity="0.7" />
        </g>
        <g className="animate-steam-delayed">
          <rect x="6" y="2" width="1" height="1" fill="#9ca3af" opacity="0.5" />
          <rect x="8" y="1" width="1" height="1" fill="#9ca3af" opacity="0.6" />
        </g>

        {/* Cup body */}
        <rect x="3" y="4" width="10" height="1" fill="#8B4513" /> {/* Top rim */}
        <rect x="3" y="5" width="10" height="1" fill="#D2691E" /> {/* Coffee surface */}
        <rect x="3" y="6" width="10" height="5" fill="#F5DEB3" /> {/* Cup body */}
        <rect x="4" y="11" width="8" height="1" fill="#F5DEB3" /> {/* Bottom taper */}
        <rect x="5" y="12" width="6" height="1" fill="#DEB887" /> {/* Cup bottom */}

        {/* Cup shading */}
        <rect x="3" y="6" width="1" height="5" fill="#DEB887" /> {/* Left shadow */}
        <rect x="12" y="6" width="1" height="5" fill="#FAEBD7" /> {/* Right highlight */}

        {/* Handle */}
        <rect x="13" y="6" width="1" height="1" fill="#DEB887" />
        <rect x="14" y="6" width="1" height="3" fill="#DEB887" />
        <rect x="13" y="9" width="1" height="1" fill="#DEB887" />

        {/* Coffee liquid highlight */}
        <rect x="5" y="5" width="2" height="1" fill="#A0522D" opacity="0.5" />
      </svg>

      <style>{`
        @keyframes steam {
          0%, 100% {
            transform: translateY(0);
            opacity: 0.7;
          }
          50% {
            transform: translateY(-2px);
            opacity: 0.3;
          }
        }

        @keyframes steam-delayed {
          0%, 100% {
            transform: translateY(0);
            opacity: 0.5;
          }
          50% {
            transform: translateY(-3px);
            opacity: 0.2;
          }
        }

        .animate-steam {
          animation: steam 2s ease-in-out infinite;
        }

        .animate-steam-delayed {
          animation: steam-delayed 2s ease-in-out infinite 0.5s;
        }
      `}</style>
    </div>
  );
};

export default PixelCoffee;
